import { render, staticRenderFns } from "./RolePermissionTab.vue?vue&type=template&id=bf89befe&scoped=true&"
import script from "./RolePermissionTab.vue?vue&type=script&lang=js&"
export * from "./RolePermissionTab.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionTab.vue?vue&type=style&index=0&id=bf89befe&lang=scss&scoped=true&"
import style1 from "./RolePermissionTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf89befe",
  null
  
)

export default component.exports